<!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
<script setup>
/* eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text */
import {
  kindActionLabel,
  kindVisual,
  number,
} from '../utils/pendentesFormatters';

defineProps({
  tipos: { type: Array, default: () => [] },
  activeKind: { type: String, default: '' },
});

const emit = defineEmits(['select']);
</script>

<template>
  <div
    class="w-full min-w-0 max-w-full shrink-0 overflow-x-hidden border-b border-lais-border bg-white px-4 sm:px-6 lg:px-10"
  >
    <nav
      class="grid grid-cols-1 gap-2 py-3 sm:grid-cols-2 lg:flex lg:overflow-x-auto lg:pb-3 no-scrollbar"
      aria-label="Tipos de pendentes"
    >
      <button
        v-for="tipo in tipos"
        :key="tipo.kind"
        type="button"
        class="group flex min-w-0 items-center gap-3 rounded-lais border px-3 py-2 text-left transition-colors lg:min-w-[190px] lg:shrink-0 lg:rounded-full"
        :class="
          activeKind === tipo.kind
            ? 'border-lais-primary bg-lais-primary-50 text-lais-primary'
            : 'border-lais-border bg-white text-lais-text-body hover:border-lais-primary hover:text-lais-primary'
        "
        :aria-pressed="activeKind === tipo.kind"
        @click="emit('select', tipo.kind)"
      >
        <span
          class="grid size-9 shrink-0 place-items-center rounded-full bg-white shadow-lais-soft"
          :class="kindVisual(tipo.kind).tone"
        >
          <span
            class="size-4"
            :class="kindVisual(tipo.kind).icon"
            aria-hidden="true"
          />
        </span>
        <span class="min-w-0 flex-1">
          <span class="block truncate text-[13px] font-semibold">
            {{ tipo.label }}
          </span>
          <span class="block truncate text-[11px] opacity-75">
            {{ kindActionLabel(tipo.kind) }}
          </span>
        </span>
        <span
          class="rounded-full bg-white px-2 py-0.5 text-[11px] font-bold text-lais-text shadow-lais-soft"
        >
          {{ number(tipo.total) }}
        </span>
      </button>
    </nav>
  </div>
</template>
